var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicker01 = function SvgTicker01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ticker-01_svg2__a",
    x1: 26.86,
    x2: 172.43,
    y1: 165.93,
    y2: 1.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticker-01_svg2__a",
    id: "ticker-01_svg2__b",
    x1: 21.58,
    x2: 167.15,
    y1: 161.26,
    y2: -3.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticker-01_svg2__a",
    id: "ticker-01_svg2__c",
    x1: 49.76,
    x2: 195.33,
    y1: 186.21,
    y2: 21.82
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticker-01_svg2__a",
    id: "ticker-01_svg2__d",
    x1: 73.78,
    x2: 219.35,
    y1: 207.48,
    y2: 43.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticker-01_svg2__a",
    id: "ticker-01_svg2__e",
    x1: 93.64,
    x2: 239.2,
    y1: 225.06,
    y2: 60.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticker-01_svg2__a",
    id: "ticker-01_svg2__f",
    x1: 102.71,
    x2: 248.27,
    y1: 233.09,
    y2: 68.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticker-01_svg2__a",
    id: "ticker-01_svg2__g",
    x1: 100.99,
    x2: 246.56,
    y1: 231.58,
    y2: 67.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticker-01_svg2__a",
    id: "ticker-01_svg2__h",
    x1: 21.9,
    x2: 167.47,
    y1: 161.54,
    y2: -2.86
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M119.93 8.56a6.666 6.666 0 0 0-5.66-7.54C109.6.35 104.84.01 99.99.01 44.77 0 0 44.77 0 100s44.77 100 100 100c4.84 0 9.61-.34 14.28-1.01 3.64-.52 6.18-3.9 5.66-7.54s-3.9-6.18-7.54-5.66c-4.04.58-8.18.88-12.39.88-47.86 0-86.67-38.8-86.67-86.67S52.14 13.33 100 13.33c4.21 0 8.35.3 12.39.88 3.64.52 7.02-2.01 7.54-5.66Z",
    style: {
      fill: "url(#ticker-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.67,
    cy: 20,
    r: 13.33,
    style: {
      fill: "url(#ticker-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.33,
    cy: 46.67,
    r: 13.33,
    style: {
      fill: "url(#ticker-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.67,
    cy: 80,
    r: 13.33,
    style: {
      fill: "url(#ticker-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.67,
    cy: 120,
    r: 13.33,
    style: {
      fill: "url(#ticker-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.33,
    cy: 153.33,
    r: 13.33,
    style: {
      fill: "url(#ticker-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.67,
    cy: 180,
    r: 13.33,
    style: {
      fill: "url(#ticker-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.33 46.67v50.57l-24.71 24.71c-2.6 2.6-2.6 6.82 0 9.43 2.6 2.6 6.82 2.6 9.43 0l26.67-26.67a6.67 6.67 0 0 0 1.95-4.71V46.67c0-3.68-2.99-6.67-6.67-6.67s-6.67 2.99-6.67 6.67",
    style: {
      fill: "url(#ticker-01_svg2__h)"
    }
  }));
};
export default SvgTicker01;